export default __webpack_public_path__ + "static/media/bnb.90f94bb3.jpg";